<template>
  <div>
    <ui-stage>
      <ui-flex row>
        <ui-flex style="flex: 0 0 110px" class="mr br pr">
          <app-links-list v-model="filter" :data="projects" with-search />
        </ui-flex>
        <ui-flex>
          <ui-admin-table
            v-if="data"
            :attributes="attributes"
            :data="data"
            :module-url="moduleUrl"
            pagination-method="front-end"
            :link-create="linkCreate"
            :with-create="canCreate"
          >
            <template v-slot:column__adminActions="scope">
              <ui-button-group>
                <router-link :to="`${moduleUrl}/edit/${scope.row.id}`">
                  <ui-button
                    size="mini"
                    type="primary"
                    icon="el-icon-view"
                    v-if="!canEdit(scope.row.id, scope.row.project_id)"
                    >查看</ui-button
                  >
                  <ui-button size="mini" type="primary" icon="el-icon-edit" v-else>编辑</ui-button>
                </router-link>
                <router-link
                  :to="`${moduleUrl}/delete/${scope.row.id}?backUrl=${encodeURIComponent(
                    $route.fullPath,
                  )}`"
                  v-if="canDelete(scope.row.id, scope.row.project_id)"
                >
                  <ui-button size="mini" type="info" icon="el-icon-delete">删除</ui-button>
                </router-link>
              </ui-button-group>
            </template>
            <template v-slot:column__status="scope">
              <el-tag :type="getStatusTagType(scope.row.status)" size="mini">
                {{ scope.row.status }}
              </el-tag>
            </template>
            <template v-slot:column__attachments="scope">
              <div v-if="scope.row.attachments && scope.row.attachments.length > 0">
                <el-image
                  v-for="(attachment, index) in scope.row.attachments.slice(0, 3)"
                  :key="index"
                  :src="attachment"
                  :preview-src-list="scope.row.attachments"
                  style="width: 40px; height: 40px; margin-right: 5px"
                  fit="cover"
                />
                <span v-if="scope.row.attachments.length > 3" class="text-muted">
                  +{{ scope.row.attachments.length - 3 }}
                </span>
              </div>
              <span v-else class="text-muted">无附件</span>
            </template>
          </ui-admin-table>
        </ui-flex>
      </ui-flex>
    </ui-stage>
  </div>
</template>

<script>
import { adminList } from '@yishitec/web/mixins';
import AppLinksList from '../../../components/AppLinksList.vue';
import withProjectsFilters from '../../../mixins/withProjectsFilters';
import permissions from '../../../mixins/permissions';

/**
 * @typedef {WithAdminList & WithProjectsFilter & WithPermissions} This
 * */

export default {
  name: 'CitizenComplaintsList',
  components: { AppLinksList },
  mixins: [adminList, withProjectsFilters, permissions],
  data() {
    return {
      apiBodyData: {
        currentProjects: this.$store.state.currentProjects,
      },
    };
  },
  computed: {
    canCreate() {
      /** @type {This} */
      const that = this;
      if (!that.filter) return false;
      // 仅建设单位管理人员可以创建
      return that.amI(that.filter, '建设单位', '管理人员', true);
    },
    linkCreate() {
      return `/admin/citizen-complaints/add?project_id=${this.filter}`;
    },
  },
  methods: {
    canEdit(rowId, projectId) {
      /** @type {This} */
      const that = this;
      // 建设单位、施工单位、监理单位可以编辑不同字段
      return (
        that.amI(projectId, '建设单位', '管理人员', true) ||
        that.amI(projectId, '施工单位', '安全员', true) ||
        that.amI(projectId, '施工单位', '管理人员', true) ||
        that.amI(projectId, '监理单位', '管理人员', true)
      );
    },
    canDelete(rowId, projectId) {
      /** @type {This} */
      const that = this;
      // 仅建设单位管理人员可以删除
      return that.amI(projectId, '建设单位', '管理人员', true);
    },
    getStatusTagType(status) {
      const statusMap = {
        待整改: 'warning',
        已整改: 'success',
        待审核: 'info',
        已取消: 'danger',
      };
      return statusMap[status] || 'info';
    },
  },
};
</script>

<style lang="less" scoped>
.text-muted {
  color: #999;
  font-size: 12px;
}
</style>
